import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWfProductStore } from 'src/api/wf/stores/WfProductStore';
import WF_Header from '../../common/header/WfHeader';
import useWfProductService from 'src/api/wf/service/WfProductService';
import { useWfWorkplaceStore } from 'src/api/wf/stores/WfWorkplaceStore';

function WF_4_9_2_ProductList() {
  const { t } = useTranslation();
  const { products } = useWfProductStore();
  const { selectedWorkplace } = useWfWorkplaceStore();
  const { fetchProducts } = useWfProductService();

  useEffect(() => {
    if (
      selectedWorkplace?.customerId &&
      selectedWorkplace?.branchCode &&
      selectedWorkplace?.details?.disasterId
    ) {
      fetchProducts({
        branchCode: selectedWorkplace.branchCode,
        customerId: selectedWorkplace.customerId,
        disasterId: selectedWorkplace.details.disasterId,
      });
    }
  }, [
    selectedWorkplace?.customerId,
    selectedWorkplace?.branchCode,
    selectedWorkplace?.details?.disasterId,
    fetchProducts,
  ]);

  return (
    <div className="min-h-screen bg-gray-100">
      <WF_Header />
      <div className="p-4">
        <div className="mb-4 text-lg font-bold">{t('wf.productList.title')}</div>
        {selectedWorkplace && (
          <div className="mb-4 rounded-lg bg-white p-4 shadow">
            <div className="text-sm text-gray-600">
              {t('wf.common.customerNumber')}: {selectedWorkplace.customerId}
            </div>
            <div className="text-sm text-gray-600">
              {t('wf.propertyList.buildingName')}: {selectedWorkplace.name}
            </div>
            <div className="text-sm text-gray-600">
              {t('wf.productList.branchCode')}:{' '}
              {selectedWorkplace.branchCode && selectedWorkplace.branchName
                ? `${selectedWorkplace.branchCode} ${selectedWorkplace.branchName}`
                : selectedWorkplace.branchName || selectedWorkplace.branchCode || ''}
            </div>
          </div>
        )}
        {products.length === 0 ? (
          <div className="p-4 text-center text-gray-500">{t('wf.productList.noProducts')}</div>
        ) : (
          <div className="space-y-2">
            {products.map((product, index) => (
              <div
                key={`${product.productNumber}-${index}`}
                className="rounded-lg border border-gray-200 bg-white p-4 shadow"
              >
                <div className="flex flex-col gap-2">
                  <div className="flex flex-row gap-4">
                    <div className="flex-1">
                      <div className="text-xs text-gray-500">
                        {t('wf.productList.productNumber')}
                      </div>
                      <div className="font-semibold">{product.productNumber}</div>
                    </div>
                    <div className="flex-1">
                      <div className="text-xs text-gray-500">
                        {t('wf.productList.machineNumber')}
                      </div>
                      <div className="font-semibold">{product.unit}</div>
                    </div>
                  </div>
                  {product.model && (
                    <div>
                      <div className="text-xs text-gray-500">{t('wf.productList.model')}</div>
                      <div>{product.model}</div>
                    </div>
                  )}
                  {product.statusName && (
                    <div>
                      <div className="text-xs text-gray-500">{t('wf.common.status')}</div>
                      <div>{product.statusName}</div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default WF_4_9_2_ProductList;
